export class ArMarker {
  id: string;
  img: string;
  title: string;
  static get list(): ArMarker[] {
    const list: ArMarker[] = [];
    list.push({
      id: 'hiro',
      img: '../public/ar_marker/hero_ar.png',
      title: 'HIRO Marker (Default)',
    });
    for (let i = 0; i < 64; i++) {
      const barcode = new String('0' + i).substr(-2);
      list.push({
        id: barcode,
        img: '../public/ar_marker/' + barcode + '.png',
        title: 'QRCode Marker(' + i + ')',
      });
    }
    return list;
  }
}
